import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import DashboardLayout from '../Layout/DashboardLayout';
import LoadingSpinner from '../Common/LoadingSpinner';
import { requestHelpers } from '../../services/api';
import './BusinessInsights.css';

const BusinessInsights = () => {
    const [insights, setInsights] = useState(null);
    const [loading, setLoading] = useState(true);
    const [dateRange, setDateRange] = useState('LAST_30_DAYS');

    useEffect(() => {
        fetchInsights();
    }, [dateRange]);

    const fetchInsights = async () => {
        try {
            setLoading(true);
            const response = await requestHelpers.get(`/analytics/business`, {
                params: { range: dateRange }
            });
            setInsights(response.data);
        } catch (error) {
            console.error('Failed to fetch insights:', error);
            toast.error('Failed to load business insights');
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <LoadingSpinner />;

    return (
        <DashboardLayout>
            <div className="business-insights">
                <header className="insights-header">
                    <div>
                        <h1>Business Insights</h1>
                        <p>Deep dive into your WhatsApp conversation metrics and costs.</p>
                    </div>
                    <div className="range-selector">
                        <select value={dateRange} onChange={(e) => setDateRange(e.target.value)}>
                            <option value="LAST_7_DAYS">Last 7 Days</option>
                            <option value="LAST_30_DAYS">Last 30 Days</option>
                            <option value="LAST_90_DAYS">Last 90 Days</option>
                        </select>
                    </div>
                </header>

                <div className="insights-grid">
                    {/* Conversation Categories */}
                    <div className="insight-card category-card">
                        <h3>Conversation Categories</h3>
                        <div className="category-stats">
                            <div className="stat-item marketing">
                                <span className="label">Marketing</span>
                                <div className="bar-container">
                                    <div className="bar" style={{ width: '45%' }}></div>
                                </div>
                                <span className="value">45%</span>
                            </div>
                            <div className="stat-item utility">
                                <span className="label">Utility</span>
                                <div className="bar-container">
                                    <div className="bar" style={{ width: '30%' }}></div>
                                </div>
                                <span className="value">30%</span>
                            </div>
                            <div className="stat-item service">
                                <span className="label">Service</span>
                                <div className="bar-container">
                                    <div className="bar" style={{ width: '15%' }}></div>
                                </div>
                                <span className="value">15%</span>
                            </div>
                            <div className="stat-item auth">
                                <span className="label">Authentication</span>
                                <div className="bar-container">
                                    <div className="bar" style={{ width: '10%' }}></div>
                                </div>
                                <span className="value">10%</span>
                            </div>
                        </div>
                    </div>

                    {/* Cost Summary */}
                    <div className="insight-card cost-card">
                        <h3>Total Cost (Est.)</h3>
                        <div className="total-amount">₹4,250.00</div>
                        <div className="cost-breakdown">
                            <div className="cost-item">
                                <p>Paid Conversations</p>
                                <span>₹3,800.00</span>
                            </div>
                            <div className="cost-item">
                                <p>Free Tier Usage</p>
                                <span>850 / 1000</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="details-section">
                    <div className="performance-table-card">
                        <h3>Template Performance</h3>
                        <table className="insights-table">
                            <thead>
                                <tr>
                                    <th>Template Name</th>
                                    <th>Category</th>
                                    <th>Volume</th>
                                    <th>Cost</th>
                                    <th>Read Rate</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>winter_sale_promotion</td>
                                    <td>Marketing</td>
                                    <td>1,240</td>
                                    <td>₹892.80</td>
                                    <td><span className="rate positive">92%</span></td>
                                </tr>
                                <tr>
                                    <td>otp_verification</td>
                                    <td>Authentication</td>
                                    <td>850</td>
                                    <td>₹212.50</td>
                                    <td><span className="rate">98%</span></td>
                                </tr>
                                <tr>
                                    <td>order_confirmation</td>
                                    <td>Utility</td>
                                    <td>430</td>
                                    <td>₹129.00</td>
                                    <td><span className="rate negative">74%</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default BusinessInsights;
